import SVGLoader from './SVGLoader';

const PhoneHangUpIcon = props => {
  const { width, height, viewboxWidth, viewboxHeight } = props;

  return (
    <SVGLoader
      {...props}
      width={width || 24}
      height={height || 9}
      viewboxWidth={viewboxWidth || 24}
      viewboxHeight={viewboxHeight || 9}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.18975 1.46106C6.3169 0.534839 8.56777 0.134135 10.881 0.0279125C13.4502 -0.0900341 15.9681 0.158014 18.4045 0.921159C19.6436 1.30923 20.8409 1.80559 21.8411 2.60576C23.4815 3.91826 24.3902 5.31677 23.8383 7.4108C23.5347 8.56343 22.9362 8.9967 21.6933 8.98431C20.626 8.97364 19.5769 8.85283 18.5636 8.52958C17.9354 8.32905 17.5636 7.91996 17.4802 7.30224C17.4173 6.83519 17.3408 6.35788 17.3798 5.89187C17.4632 4.88968 16.8774 4.37058 16.0099 4.04327C14.3625 3.4215 12.6277 3.36284 10.8758 3.46153C9.80737 3.52195 8.76106 3.69143 7.76965 4.11815C7.01678 4.44221 6.59032 4.93897 6.62135 5.75661C6.6397 6.23872 6.59567 6.72534 6.55533 7.20847C6.4902 7.99176 5.99992 8.47546 5.22221 8.6272C4.31926 8.80302 3.40019 8.95812 2.48429 8.99566C1.02745 9.05554 0.359154 8.4985 0.0967346 7.13333C-0.122609 5.99228 0.0167546 4.90947 0.66222 4.17892C1.68228 2.80401 2.8641 2.0381 4.18975 1.46106Z"
        fill="white"
      />
    </SVGLoader>
  );
};

export default PhoneHangUpIcon;
